import { ExternalSmsMarketingProvider } from "@redotech/redo-marketing-settings-common/external-sms-marketing-provider";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getExternalSmsMarketingProviderStatus = {
  name: "getExternalSmsMarketingProviderStatus" as const,
  input: z.object({}),
  output: z.object({
    currentProvider: createEnum(ExternalSmsMarketingProvider).nullable(),
    integrations: z.object({
      attentive: z.object({
        exists: z.boolean(),
        hasRecoverPurpose: z.boolean(),
      }),
      klaviyo: z.object({ exists: z.boolean() }),
      postscript: z.object({ exists: z.boolean() }),
    }),
  }),
  mock: {
    currentProvider: null,
    integrations: {
      attentive: { exists: false, hasRecoverPurpose: false },
      klaviyo: { exists: false },
      postscript: { exists: false },
    },
  },
};
